/**
 * 404 Not Found page component
 */

import { Link } from 'react-router-dom';
import { Button } from '../components/common';
import './NotFound.css';

/**
 * 404 error page
 * @returns {React.ReactElement} Not found page element
 */
export default function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found__content">
        <h1 className="not-found__code">404</h1>
        <h2 className="not-found__title">Page Not Found</h2>
        <p className="not-found__message">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link to="/dashboard">
          <Button>Go to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
